import React from 'react';
import {Image} from './Image';

const Cover = (props) => (
  <li className="book-book--cover" id={props.id}>
    <Image type={props.type} class={props.class} id={props.id} img={props.img}></Image>
    <div className="page-name">page id: <span className="page-name__name">{props.id}</span></div>
  </li>
)

export default Cover



// WEBPACK FOOTER //
// ./src/components/Cover.js